export default "__VITE_ASSET__DhBO_7HN__"